import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {environment} from '../../../environments/environment';
import {HttpClient} from '@angular/common/http';
import {Subscription} from 'rxjs';

@Component({
    selector: 'app-submitted-questionnaire',
    templateUrl: './submitted-questionnaire.component.html',
    styleUrls: ['./submitted-questionnaire.component.scss'],
})
export class SubmittedQuestionnaireComponent implements OnInit, OnDestroy {
    confirmationText: string | null = null;
    subscriptions: Subscription[] = [];

    constructor(
        private route: ActivatedRoute,
        private translate: TranslateService,
        private http: HttpClient,
    ) {}

    ngOnInit(): void {
        this.translate.use(this.route.snapshot.params['lang']);

        this.subscriptions.push(
            this.http
                .get<{confirmationText: string}>(
                    environment.nieuwkomer_api + '/get-confirmation-text',
                    {params: {lang: this.route.snapshot.params['lang']}},
                )
                .subscribe(output => {
                    this.confirmationText = output.confirmationText;
                }),
        );
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(s => s.unsubscribe());
    }
}
